<template>
    <div id="app">
        <loading :is-loading="isLoading"></loading>
        <!-- Le component est notre layout. Le contenu de chaque page est injecté dedans-->
        <layout-default>
            <error-boundary>
                <keep-alive>
                    <router-view />
                </keep-alive>
            </error-boundary>
        </layout-default>
    </div>
</template>

<script>
import Http from '@/services/HttpApi';
import ErrorBoundary from '@/components/error/ErrorBoundary.vue';
import Loading from '@/components/loading.vue';
import LayoutDefault from '@/components/layout/LayoutDefault.vue';

export default {
  name: 'app',
  components: { LayoutDefault, Loading, ErrorBoundary },
  data() {
    return {
      msg: 'Welcome to your Vue.js powered Spring Boot App',
      refCount: 0,
      isLoading: false,
    };
  },
  computed: {
    alerte() {
      return this.$store.state.alerte;
    },
  },
  watch: {
    $route(to, from) { // eslint-disable-line
      // clear alert on location change
      // this.$store.dispatch('alerte/clear');
    },
  },
  methods: {
    setLoading(inbOn) {
      // this.$log.debug('App.setLoading', inbOn);
      if (inbOn) {
        this.refCount += 1;
        this.isLoading = true;
      } else if (this.refCount > 0) {
        this.refCount -= 1;
        this.isLoading = (this.refCount > 0);
      }
    },
    async getPermissions() {
      const srvApi = await new Http(this.setLoading);
      this.$log.info('App.getPermissions ', srvApi);
      return srvApi;
    },
    async getFingerPrint() {
      const sResult = await Http.getFingerPrint();
      this.$log.info('App.getFingerPrint ', sResult);
      return sResult;
    },
  },
  created() {
    this.getFingerPrint();
    this.getPermissions();
  },
  mounted() {
    // $('[data-toggle="tooltip"]').tooltip();
  },

};
</script>

<style lang="scss">

caption{
    caption-side: top;
    border-bottom: 2px solid #ddd;
    margin-bottom: 15px;
    color: #333;
    font-weight: bold;
}

#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
     color: #42b983;
    }
  }
}
[v-cloak] {
  display: none;
}

.tooltip {
    display: block !important;
    z-index: 10000;
}

.tooltip .tooltip-inner {
    /*background: black;*/
    /*color: white;*/
    background: #fff;
    color: black;
    border: 1px solid #999;
    /*border-radius: 16px;*/
    padding: 0;
    /*padding: 5px 10px 4px;*/
    max-width: 400px;
    box-shadow: 0 5px 10px rgba(0,0,0,.2);
}

.tooltip .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: #999;
    z-index: 1;

}

.tooltip[x-placement^="top"] {
    margin-bottom: 5px;
}

.tooltip[x-placement^="top"] .tooltip-arrow {
    border-width: 5px 5px 0 5px;
    border-left-color: transparent !important;
    border-right-color: transparent !important;
    border-bottom-color: transparent !important;
    bottom: -5px;
    left: calc(50% - 5px);
    margin-top: 0;
    margin-bottom: 0;
}

.tooltip[x-placement^="bottom"] {
    margin-top: 5px;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
    border-width: 0 5px 5px 5px;
    border-left-color: transparent !important;
    border-right-color: transparent !important;
    border-top-color: transparent !important;
    top: -5px;
    left: calc(50% - 5px);
    margin-top: 0;
    margin-bottom: 0;

    /*<!--top: -5px;-->*/
    /*<!--left:calc(50% - 5px);-->*/
    /*<!--margin-top: -15px;-->*/
    /*<!--margin-bottom: 0;-->*/
    /*border-left-width: 0;*/
    /*border-right-color: #999;*/
    /*border-right-color: rgba(0,0,0,.25);*/
    border-top-width: 0;
    /*border-bottom-color: red;*/
    /*border-bottom-color: rgba(0,0,0,.25);*/
    /*border-width: 11px;*/
}

/*.tooltip[x-placement^="bottom"] .tooltip-arrow:after {*/
    /*position: absolute;*/
    /*display: block;*/
    /*width: 0;*/
    /*height: 0;*/
    /*border-color: transparent;*/
    /*border-style: solid;*/
    /*box-sizing: border-box;*/
    /*!*content: " ";*!*/
    /*!*left: 1px;*!*/
    /*!*<!--bottom: -10px;-->*!*/
    /*!*border-left-width: 0;*!*/
    /*!*border-right-color: red;*!*/
    /*!*border-width: 10px;*!*/
/*}*/
.tooltip[x-placement^="right"] {
    margin-left: 5px;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
    border-width: 5px 5px 5px 0;
    border-left-color: transparent !important;
    border-top-color: transparent !important;
    border-bottom-color: transparent !important;
    left: -5px;
    top: calc(50% - 5px);
    margin-left: 0;
    margin-right: 0;
}

.tooltip[x-placement^="left"] {
    margin-right: 5px;
}

.tooltip[x-placement^="left"] .tooltip-arrow {
    border-width: 5px 0 5px 5px;
    border-top-color: transparent !important;
    border-right-color: transparent !important;
    border-bottom-color: transparent !important;
    right: -5px;
    top: calc(50% - 5px);
    margin-left: 0;
    margin-right: 0;
}

.tooltip.popover .popover-inner {
    background: #f9f9f9;
    color: red;
    padding: 24px;
    /*border-radius: 5px;*/
    box-shadow: 0 5px 30px rgba(red, .1);
}

.tooltip.popover .popover-arrow {
    border-color: #f9f9f9;
}

.tooltip[aria-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transition: opacity .15s, visibility .15s;
}

.tooltip[aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition: opacity .15s;
}
</style>
